import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import getLocale from '../../i18n/getLocale';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

class RolesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      id: '',
      name: '',
      emails: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addEmail = this.addEmail.bind(this);
    this.deleteEmail = this.deleteEmail.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/setor/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/setors');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            emails: responseJson.data.emails,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); 
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/setor', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Salva role email
  addEmail(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      sector_id: this.state.id,
      email: this.state.email,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/setor/email', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({emails: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteEmail (sector_email_id) {
    var confirm = window.confirm(this.locale.Setores.EditarSetor.deletarEmail);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/setor/email/' + sector_email_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({emails: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Setores.EditarSetor.titulo}</h3>
      <Link to="/setores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        <Tab eventKey={1} title="Dados">
          <form onSubmit={this.edit}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Setores.EditarSetor.formulario.Nome}:</label>
                  <input type="text" name="name" className="form-control" placeholder={this.locale.Setores.EditarSetor.formulario.placeholder.registroDoSetor} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
                </div>
              </div>
              <div className="col-md-6">
                <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
              </div>
            </div>
          </form>
        </Tab>
        <Tab eventKey={2} title="Emails">
          <form onSubmit={this.addEmail}>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.Setores.EditarSetor.formulario.Email}:</label>
                  <input type="text" name="email" className="form-control" placeholder={this.locale.Setores.EditarSetor.formulario.placeholder.emailDoSetor} value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <button type="submit" className="btn btn-primary btn-inline btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Setores.EditarSetor.formulario.botaoAdicionarEmail}</button>
                </div>
              </div>
            </div>
          </form>
          <hr/>
          {(this.state.emails === null || typeof this.state.emails === 'undefined') ?  ''
          :
            <table className="table">
              <thead>
                <tr>
                  <th>
                    {this.locale.Setores.EditarSetor.tabela.Email}
                  </th>
                  <th>{this.locale.Setores.EditarSetor.Acoes}</th>
                </tr>
              </thead>
              <tbody id="suppliers-certifications">
                {Object.keys(self.state.emails).map(function(k) {
                  return (
                    <tr>
                      <td>
                        {self.state.emails[k].email}
                      </td>
                      <td>
                        <div className="btn-group">
                          <button className="btn btn-sm btn-danger" onClick={() => {self.deleteEmail(self.state.emails[k].id)}}>
                            <i className="fa fa-fw fa-trash"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          }
        </Tab>
      </Tabs>
    </div>
  </div>
</div>
    );
  }
}

export default RolesEdit;



// WEBPACK FOOTER //
// ./src/Components/Sectors/SectorsEdit.js